import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  align-self:center; 
  border: none;
`;

class CardFlatworm extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Coverbg src= {'https://reefbuilders.com/wp-content/blogs.dir/1/files/2015/09/aefw-amakusaplana-acropora-bite-marks-1.jpg'}/>      
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Great Barrier Reef"
   diagnosis="Flatworm, also known as Amakusaplana acroporae, is a parasite that has been identified at the Great Barrier Reef. The flatworm infects a type of staghorn coral known as acropora, a vital component of reefs. "
   prediction="This parasite lacks known natural predators. Researchers are concerned it could spread quickly and decimate reefs worldwide (Yale Environment)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardFlatworm;
